import axios from "@/libs/api.request";

export const SaveVersion = data => {
  return axios.request({
    url: "/print/version/save",
    data,
    method: "post"
  });
};

export const GetVersionMachine = data => {
  return axios.request({
    url: '/print/version/all-machine',
    params: data,
    method: 'get'
  });
};

export const GetVersionList = data => {
  return axios.request({
    url: '/print/version/list',
    params: data,
    method: 'get'
  });
};
export const GetSoftwareList = data => {
  return axios.request({
    url: '/print/version/software',
    params: data,
    method: 'get'
  });
};
export const GetMachineListData = data => {
  return axios.request({
    url: '/print/version/machine',
    params: data,
    method: 'get'
  });
};
